var map = {
	"./biscoffTiramisu.png": 587,
	"./carrotWalnutCake.png": 983,
	"./coffee.jpg": 367,
	"./halloweenPumpkin.png": 196,
	"./hotChoco.png": 470,
	"./kyotosSummer.png": 647,
	"./mangoCheesecake.png": 50,
	"./orange_swissroll.png": 624,
	"./scones.png": 534,
	"./smoresChocolatePie.png": 968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 180;